export const products = [
  {
    id: 'handstand-canes',
    name: 'Handstand Canes (60 CM)',
    tagline: 'Built for Balance & Control',
    description: 'Built for balance, control, and serious handstand practice. Designed to give perfect elevation for improving alignment, shoulder strength, and body awareness.',
    longDescription: 'Whether you are working on your first handstand or refining advanced shapes, these canes offer the stability and elevation you need. The 60 CM height provides optimal wrist positioning, reducing strain while enabling deeper control over your balance. Each pair is built to withstand rigorous daily training while remaining portable enough for travel.',
    price: 7999,
    rating: 4.9,
    reviews: 28,
    images: [
      'https://images.pexels.com/photos/6571951/pexels-photo-6571951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    ],
    features: [
      'Solid and stable construction',
      'Comfortable grip for better control',
      'Ideal for handstand training and progressions',
      '60 CM height for optimal positioning',
    ],
    specs: {
      Height: '60 cm',
      Material: 'Premium hardwood',
      'Grip Diameter': 'Ergonomic fit',
      'Weight Capacity': 'Heavy-duty support',
    },
    uses: 'Designed for handstand practice, alignment drills, shoulder strengthening, and balance training. Suitable for beginners through advanced practitioners working on one-arm handstands and shape transitions.',
    inStock: true,
    badge: null,
  },
  {
    id: 'fingerboard',
    name: 'Fingerboard (Two-Stones Style)',
    tagline: 'Build Unbreakable Grip Strength',
    description: 'A versatile fingerboard designed to build finger strength, grip, and tendon resilience. Inspired by the popular two-stones style.',
    longDescription: 'This fingerboard brings precision grip training into your home or gym. Multiple edge depths and pocket sizes let you progress from beginner hangs to advanced one-arm work. The natural wood finish provides excellent skin friction without being harsh on your fingers.',
    price: 4999,
    rating: 4.8,
    reviews: 42,
    images: [
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/z1yve0yy_WhatsApp%20Image%202026-03-29%20at%201.45.07%20PM%20%281%29.jpeg',
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/ko6bfmbj_WhatsApp%20Image%202026-03-29%20at%201.45.07%20PM%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/oc1l0wso_WhatsApp%20Image%202026-03-29%20at%201.45.07%20PM.jpeg',
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/5edp2vpg_WhatsApp%20Image%202026-03-29%20at%201.45.08%20PM.jpeg',
    ],
    features: [
      'Multiple grip options for progressive training',
      'Strong and durable wooden build',
      'Ideal for grip strength & injury prevention',
      'Two-stones style inspired design',
    ],
    specs: {
      Style: 'Two-Stones inspired',
      Material: 'Natural hardwood',
      Mounting: 'Wall-mounted (hardware included)',
      'Grip Edges': 'Multiple depths & pockets',
    },
    uses: 'Perfect for climbers, calisthenics athletes, and anyone looking to develop serious finger and forearm strength. Use for dead hangs, repeaters, max hangs, and progressive finger training.',
    inStock: true,
    badge: null,
  },
  {
    id: 'peg-board',
    name: 'Peg Board (4ft x 2ft)',
    tagline: 'Challenge Your Upper Body',
    description: 'A classic upper body strength tool that challenges your pulling power, coordination, and endurance.',
    longDescription: 'The peg board is one of the most effective upper body training tools available. By climbing with alternating pegs, you develop pulling strength, shoulder stability, and grip endurance simultaneously. Our 4ft x 2ft board is sized perfectly for home gyms while providing enough height for a serious workout.',
    price: 4999,
    rating: 4.7,
    reviews: 19,
    images: [
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/50uxpoao_WhatsApp%20Image%202026-03-29%20at%201.51.30%20PM.jpeg',
    ],
    features: [
      'Develops upper body strength & coordination',
      'Functional and challenging training tool',
      'Suitable for home or gym setups',
      'Includes 2 wooden pegs',
    ],
    specs: {
      Dimensions: '4ft x 2ft',
      Material: 'Solid wood construction',
      'Peg Holes': 'Evenly spaced grid pattern',
      Includes: 'Board + 2 wooden pegs',
    },
    uses: 'Used for peg board climbing, upper body pulling strength, shoulder stability, and grip endurance. A staple in functional fitness, calisthenics, and climbing training.',
    inStock: true,
    badge: null,
    imageStyle: 'contain',
  },
  {
    id: 'parallettes',
    name: 'Wooden Parallettes',
    tagline: 'Your Bodyweight Training Essential',
    description: 'Compact, durable, and essential for bodyweight training. Perfect for L-sits, planche progressions, push-ups, and handstand work.',
    longDescription: 'These parallettes are the foundation of any serious bodyweight training setup. Low to the ground yet providing enough clearance for full range of motion, they enable L-sits, planche progressions, handstand push-ups, and countless push-up variations. Their compact design makes them easy to store and transport.',
    price: 1799,
    rating: 4.9,
    reviews: 64,
    images: [
      'https://customer-assets.emergentagent.com/job_90358a1f-649a-4495-b3f9-6c9aea022b3c/artifacts/fkoxj584_WhatsApp%20Image%202026-03-29%20at%201.45.46%20PM.jpeg',
    ],
    features: [
      'Strong and stable design',
      'Comfortable grip for longer sessions',
      'Ideal for beginners to advanced athletes',
      'Compact and portable',
    ],
    specs: {
      Material: 'Solid wood with steel base',
      'Grip Diameter': 'Ergonomic 38mm',
      Height: 'Low-profile design',
      'Weight Capacity': 'Up to 150 kg',
    },
    uses: 'Essential for L-sits, planche progressions, push-up variations, handstand push-ups, and general bodyweight strength training. Used by calisthenics athletes, gymnasts, and movement practitioners worldwide.',
    inStock: true,
    badge: 'Best Seller',
  },
];

export function getProductById(id) {
  return products.find(p => p.id === id);
}
